import { Config } from '@/utils/environment';

export const useConfig = () => {
  return {
    config: Config.getAll(),
  };
};
